import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import _ from 'lodash'

import { Container as Grid, Row } from 'react-bootstrap'
import { Col } from 'react-bootstrap'
import CustomProgressBar from '../../../shared/components/CustomProgressBar'

import redDot from 'Assets/redDot.png'
import yellowDot from 'Assets/yellowDot.png'
import greenDot from 'Assets/greenDot.png'

import panelStyle from 'Styles/panel.css'
import progressBarStyle from 'Styles/progress-bar.css'
import style from './style.css'

function StudyPlanItemExpanded (props) {
  return (
    <div>
      <p className={style.topicTitle}>
        Study plan suggestions
      </p>
      <span className={props.studyPlan.length ? style.noItemsMsgDisabled : style.noItemsMsg}>
        No items available.
      </span>
      <ul className={style.suggestionList}>
        {_.map(props.studyPlan, item => {
          const itemClass = item.itemType === 'ebook' ? style.ebookItem : style.suggestionItem
          return (
            <li
              data-test-id="studyPlanItemSuggestions"
              className={itemClass}
              key={item.displayValue}
            >
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              {<a
                className={props.disableLinks ? style.studyNameDisabled : style.studyName}
                onClick={props.disableLinks ? null : () => props.itemClick(item)}
                tabIndex="0"
                dangerouslySetInnerHTML={{ __html: item.displayValue }}
              >
              </a>}
            </li>
          )
        })}

      </ul>
    </div>
  )
}
StudyPlanItemExpanded.propTypes = {
  studyPlan: PropTypes.array,
  disableLinks: PropTypes.bool,
  isStandalone: PropTypes.bool,
  itemClick: PropTypes.func.isRequired
}

function StudyPlanItemDisabled (props) {
  return (
    <div
      data-test-id="studyPlanItem"
      className={classnames(panelStyle.small, style.studyPanel, style.disabledPanel)}
      tabIndex="0"
    >
      <div
        data-test-id="studyPlanItemTitle"
        className={style.disabled}
        dangerouslySetInnerHTML={{ __html: props.label }}
      />
      <div className={style.disabledText}>
        Questions on this topic are hidden.
      </div>
    </div>
  )
}

StudyPlanItemDisabled.propTypes = {
  label: PropTypes.string.isRequired
}

function StudyPlanItemActive (props) {
  const percentage = props.totalPointsAvailable
    ? Math.round(props.totalPointsEarned / props.totalPointsAvailable * 100)
    : 0

  let topicData = null

  if (props.hasQuestions) {
    topicData = ([
      <Col
        sm={9}
        xs={9}
        key="progress-bar"
      >
        <CustomProgressBar
          dataTestId="studyPlanItemProgressBar"
          now={percentage}
          min={0}
          max={100}
          ariaLabel={`You have ${percentage} points.`}
          progressBarStyle={progressBarStyle}
          style={style}
          className={classnames(progressBarStyle.base, style.progressBar)}
          bsClass={classnames(progressBarStyle.progressValueBase, style.progressBarValue)}
        />
      </Col>,
      <Col
        sm={3}
        xs={3}
        className={style.accuracyCol}
        key="percentage-label"
        data-test-id="studyPlanItemAccuracy"
      >
        {renderGradedDot(percentage, props.fromLCRPInstructor)}
        <br className={classnames('hidden-sm', 'hidden-md', 'hidden-lg')} />
      </Col>
    ])
  } else {
    topicData = (
      <Col xs={12} sm={12} md={12} lg={12}>
        <div className={classnames(style.noQuestionsContainer)}>
          <span className={classnames(style.noQuestions)}>
            (No questions on this topic.)
          </span>
        </div>
      </Col>
    )
  }

  return (
    <div
      data-test-id="studyPlanItem"
      className={classnames({ [style.LCRPstudyPanel]: props.fromLCRPInstructor }, style.studyPanel)}
      tabIndex="0"
    >
      <div className={style.topicLabel}>{props.label}</div>
      <div className={style.topicDataContainer}>
        {topicData}
      </div>
      {props.isExpanded
        ? <StudyPlanItemExpanded {...props} />
        : null
      }
    </div>
  )
}

function renderGradedDot (score, instructor) {
  if (!instructor) {
    if (score === 0 || isNaN(score)) {
      score = '-- '
    }
    return (
      <span data-test-id="quizTopicalScore" className={style.percentage}>
        {score}%
      </span>
    )
  }
  if (score === 0 || isNaN(score)) {
    return '-- %'
  }
  let gradedDot = greenDot
  if (score < 70) {
    gradedDot = redDot
  } else if (score < 90) {
    gradedDot = yellowDot
  }
  return ([
    <img
      key={score}
      src={gradedDot}
      className={classnames(style.small, style.gradedDotImg)}
      alt={'graded dot'}
      tabIndex="-1"
    />,
    `${score}%`
  ])
}

StudyPlanItemActive.propTypes = {
  onClick: PropTypes.func,
  isExpanded: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired,
  itemClick: PropTypes.func,
  totalPointsAvailable: PropTypes.number.isRequired,
  totalPointsEarned: PropTypes.number.isRequired,
  hasQuestions: PropTypes.bool.isRequired,
  studyPlan: PropTypes.array,
  disableLinks: PropTypes.bool,
  startedStudents: PropTypes.number,
  fromLCRPInstructor: PropTypes.bool
}

function StudyPlanItemContainer (props) {
  return props.isActive ? <StudyPlanItemActive {...props} /> : <StudyPlanItemDisabled {...props} />
}

StudyPlanItemContainer.propTypes = {
  isActive: PropTypes.bool
}

export default class StudyPlanItem extends Component {
  constructor (props) {
    super(props)

    this.state = {
      isExpanded: false
    }
  }

  toggleStudyPlan () {
    this.setState({ isExpanded: !this.state.isExpanded })
  }

  render () {
    return (
      <StudyPlanItemContainer
        onClick={this.toggleStudyPlan.bind(this)}
        isExpanded={this.state.isExpanded}
        {...this.props}
      />
    )
  }
}
